import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import Link from "next/link";
import BrainLeftSidebarWaveDropTime from "@/components/brain/left-sidebar/waves/BrainLeftSidebarWaveDropTime";
import BrainLeftSidebarWavePin from "@/components/brain/left-sidebar/waves/BrainLeftSidebarWavePin";
import { WaveAvatar } from "./WaveAvatar";
import type { WaveTooltipPlacement } from "./WaveTooltip";
import { WaveTooltip } from "./WaveTooltip";
import type { MinimalWave } from "@/contexts/wave/hooks/useEnhancedWavesListCore";
interface ExpandedWaveProps {
  readonly formattedWaveName: string;
  readonly haveNewDrops: boolean;
  readonly href: string;
  readonly isActive: boolean;
  readonly isDropWave: boolean;
  readonly isPinned: boolean;
  readonly latestDropTimestamp?: number | null | undefined;
  readonly nameRef: RefObject<HTMLDivElement | null>;
  readonly onMouseEnter?: (() => void) | undefined;
  readonly onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  readonly showExpandedTooltip: boolean;
  readonly showPin: boolean;
  readonly tooltipContent: string;
  readonly tooltipId: string;
  readonly tooltipPlacement: WaveTooltipPlacement;
  readonly wave: MinimalWave;
  readonly waveId: string;
}
export const ExpandedWave = t0 => {
  const $ = _c(41);
  const {
    formattedWaveName,
    haveNewDrops,
    href,
    isActive,
    isDropWave,
    isPinned,
    latestDropTimestamp,
    nameRef,
    onMouseEnter,
    onClick,
    showExpandedTooltip,
    showPin,
    tooltipContent,
    tooltipId,
    tooltipPlacement,
    wave,
    waveId
  } = t0;
  let t1;
  if ($[0] !== showExpandedTooltip || $[1] !== tooltipContent || $[2] !== tooltipId) {
    t1 = showExpandedTooltip ? {
      "data-tooltip-id": tooltipId,
      "data-tooltip-content": tooltipContent
    } : {};
    $[0] = showExpandedTooltip;
    $[1] = tooltipContent;
    $[2] = tooltipId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const tooltipAttributes = t1;
  const presentLatestDropTimestamp = latestDropTimestamp !== null && latestDropTimestamp !== undefined && latestDropTimestamp !== 0 && Number.isFinite(latestDropTimestamp) ? latestDropTimestamp : null;
  const t2 = `tw-group tw-flex tw-items-start tw-gap-x-4 tw-px-5 tw-py-2 tw-transition-all tw-duration-200 tw-ease-out ${isActive ? "tw-bg-iron-700/60 desktop-hover:hover:tw-bg-iron-700/70" : "desktop-hover:hover:tw-bg-iron-800/80"}`;
  let t3;
  if ($[4] !== onMouseEnter) {
    t3 = onMouseEnter ? {
      onMouseEnter
    } : {};
    $[4] = onMouseEnter;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `tw-flex tw-min-w-0 tw-flex-1 tw-space-x-3 tw-py-1 tw-no-underline tw-transition-all tw-duration-200 tw-ease-out ${isActive ? "tw-font-medium tw-text-white desktop-hover:group-hover:tw-text-white" : "tw-font-normal tw-text-iron-400 desktop-hover:group-hover:tw-text-iron-300"}`;
  const t5 = !isActive && haveNewDrops;
  let t6;
  if ($[6] !== isActive || $[7] !== isDropWave || $[8] !== t5 || $[9] !== wave) {
    t6 = <div className="tw-relative"><WaveAvatar isActive={isActive} isDropWave={isDropWave} showNewDropsBadge={t5} wave={wave} /></div>;
    $[6] = isActive;
    $[7] = isDropWave;
    $[8] = t5;
    $[9] = wave;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== formattedWaveName || $[12] !== nameRef || $[13] !== tooltipAttributes) {
    t7 = <div ref={nameRef} className="-tw-mt-0.5 tw-mb-0.5 tw-truncate tw-text-sm" {...tooltipAttributes}>{formattedWaveName}</div>;
    $[11] = formattedWaveName;
    $[12] = nameRef;
    $[13] = tooltipAttributes;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== presentLatestDropTimestamp) {
    t8 = presentLatestDropTimestamp !== null && <div className="tw-text-xs tw-text-iron-500"><span className="tw-pr-1">Last drop:</span><BrainLeftSidebarWaveDropTime time={presentLatestDropTimestamp} /></div>;
    $[15] = presentLatestDropTimestamp;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="tw-min-w-0 tw-flex-1">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== href || $[21] !== onClick || $[22] !== t3 || $[23] !== t4 || $[24] !== t6 || $[25] !== t9) {
    t10 = <Link href={href} prefetch={false} {...t3} onClick={onClick} className={t4}>{t6}{t9}</Link>;
    $[20] = href;
    $[21] = onClick;
    $[22] = t3;
    $[23] = t4;
    $[24] = t6;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== isPinned || $[28] !== showPin || $[29] !== waveId) {
    t11 = showPin && <BrainLeftSidebarWavePin waveId={waveId} isPinned={isPinned} />;
    $[27] = isPinned;
    $[28] = showPin;
    $[29] = waveId;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== showExpandedTooltip || $[32] !== tooltipContent || $[33] !== tooltipId || $[34] !== tooltipPlacement) {
    t12 = showExpandedTooltip && <WaveTooltip id={tooltipId} place={tooltipPlacement}>{tooltipContent}</WaveTooltip>;
    $[31] = showExpandedTooltip;
    $[32] = tooltipContent;
    $[33] = tooltipId;
    $[34] = tooltipPlacement;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t2) {
    t13 = <div className={t2}>{t10}{t11}{t12}</div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
    $[39] = t2;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
};